export class ActionCV {

    public static all: ActionCV = new ActionCV();

    public INSERT = 'insert';
    public UPDATE = 'update';
    public DETAIL = 'detail';
    public END_PREVIOUS_START_NEW = 'endPreviousStartNew';
    public REMOVE = 'remove';
    public COPY = 'copy';
    public DEACTIVATE = 'deactivate';
    public ACTIVATE = 'activate';
    public LIST = 'list';
    public NEXT_PHASE = 'nextPhase';
    public FINISH_PHASE = 'finishPhase';
    public START_INITIAL_COORDINATION = 'startInitialCoordination';

    public SHORT_INSERT = 'I';
    public SHORT_UPDATE = 'U';
    public SHORT_DETAIL = 'D';
    public SHORT_REMOVE = 'R';
    public SHORT_DEACTIVATE = 'X';
    public SHORT_ACTIVATE = 'A';
    public SHORT_ADD_EXPIRE = 'E';
    public SHORT_REMOVE_EXPIRE = 'S';

    constructor() {
    }
}
